import React from 'react';
import { PromptAgentType } from './types';
import { AgentTypeSelect } from './AgentTypeSelect';
import { SearchInput } from '../../components/common/SearchInput';

interface PromptLibraryFiltersProps {
  selectedAgentTypes: PromptAgentType[];
  onSelectedAgentTypesChange: (value: PromptAgentType[]) => void;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
}

export const PromptLibraryFilters: React.FC<PromptLibraryFiltersProps> = ({
  selectedAgentTypes,
  onSelectedAgentTypesChange,
  searchQuery,
  onSearchQueryChange,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Agent Type Dropdown */}
      <AgentTypeSelect
        selectMode="multi"
        selectedValues={selectedAgentTypes}
        onSelectedValuesChange={onSelectedAgentTypesChange}
        placeholder="Agent Type"
      />

      {/* Search Input */}
      <SearchInput
        value={searchQuery}
        onChange={onSearchQueryChange}
        placeholder=" Search prompts..."
        containerClassName="flex-1 min-w-[200px] max-w-[320px]"
        inputClassName="placeholder-style top-heavy-input"
      />
    </div>
  );
};
